var convert = require('./convert'),
    func = convert('repeat', require('../repeat'));

func.placeholder = require('./placeholder');
module.exports = func;
